'use client';

import { useActiveAccountId } from '@frameio/shared/contexts';
import { theme } from '@frameio/vapor';
import { ProjectSettingsModal } from '@frameio/workspaces';
import { useIsQuickSearchV2Enabled } from '../hooks';
import { useQuickSearchModal as useQuickSearchModalContext } from '../shared/contexts';
import { QuickSearchDialog } from './components/QuickSearchDialog';
import { useIsQuickSearchFlyoutEnabled } from './components/QuickSearchFlyout';

const PROJECT_SETTINGS_MODAL_Z_INDEX = theme.zIndices.modal + 1;

export const QuickSearch = () => {
  const { isEnabled: isQuickSearch2Enabled } = useIsQuickSearchV2Enabled();
  const accountId = useActiveAccountId();
  const { selectedProject, clearSelectedProject } =
    useQuickSearchModalContext();

  const isProjectSettingsModalOpen = Boolean(selectedProject);
  const isQuickSearchFlyoutEnabled = useIsQuickSearchFlyoutEnabled();

  return isQuickSearch2Enabled ? (
    <>
      {!isQuickSearchFlyoutEnabled && <QuickSearchDialog />}
      <ProjectSettingsModal
        accountId={accountId}
        isShowing={isProjectSettingsModalOpen}
        onRequestClose={clearSelectedProject}
        projectId={selectedProject?.projectId ?? ''}
        trackingSource=""
        workspaceId={selectedProject?.workspaceId ?? ''}
        zIndex={PROJECT_SETTINGS_MODAL_Z_INDEX}
      />
    </>
  ) : null;
};
